var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3046 1.30458C15.6905 1.69051 15.6957 2.3146 15.3163 2.70691L10.1 8.1L15.2929 13.2929C15.6834 13.6834 15.6834 14.3166 15.2929 14.7071L14.7071 15.2929C14.3166 15.6834 13.6834 15.6834 13.2929 15.2929L8.1 10.1L2.79002 15.3215C2.40533 15.6998 1.78991 15.7047 1.39922 15.3326L0.742015 14.7067C0.335171 14.3192 0.327288 13.6727 0.724564 13.2754L5.9 8.1L0.683735 2.70691C0.30429 2.3146 0.30949 1.69051 0.69542 1.30458L1.29289 0.707106C1.68342 0.316582 2.31658 0.316582 2.70711 0.707107L7.9 5.9L13.2931 0.683735C13.6854 0.30429 14.3095 0.30949 14.6954 0.69542L15.3046 1.30458Z","fill":"currentColor"}));
}

Clear.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Clear;

Clear.default = Clear;
